module.exports = __webpack_public_path__ + "static/fanta-5-e17d07ce05145aa6b258f92c5483b2a0.jpg";